import { render } from "./SchedulingUrgencyPeople.vue?vue&type=template&id=4a2d2288&ts=true"
import script from "./SchedulingUrgencyPeople.vue?vue&type=script&lang=ts"
export * from "./SchedulingUrgencyPeople.vue?vue&type=script&lang=ts"

import "./SchedulingUrgencyPeople.vue?vue&type=style&index=0&id=4a2d2288&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__